/**
 * Mock note records for the Order Management notes feature.
 *
 * Notes are scoped to an IBO (by iboNumber) and may optionally reference a
 * specific order. The UI shows the most recent notes for an IBO with a
 * "View more" affordance, so there are deliberately more than five here for
 * one IBO to exercise the pagination path.
 */
const notes = [
  {
    id: "note_001",
    iboId: "5327982",
    orderId: "WWG897645",
    author: "Jordan Casey",
    text: "Customer called about a missing hat from this order. Confirmed re-ship.",
    createdAt: "2026-06-22T16:40:00Z",
  },
  {
    id: "note_002",
    iboId: "5327982",
    orderId: null,
    author: "Jordan Casey",
    text: "Updated shipping address per customer request.",
    createdAt: "2026-06-21T19:05:00Z",
  },
  {
    id: "note_003",
    iboId: "5327982",
    orderId: "WWG897640",
    author: "Pat Morgan",
    text: "Refund issued for damaged book. Customer satisfied.",
    createdAt: "2026-06-20T14:12:00Z",
  },
  {
    id: "note_004",
    iboId: "5327982",
    orderId: null,
    author: "Pat Morgan",
    text: "IBO prefers email contact over phone.",
    createdAt: "2026-06-18T22:30:00Z",
  },
  {
    id: "note_005",
    iboId: "5327982",
    orderId: "WWG897612",
    author: "Jordan Casey",
    text: "Added two flatbrim hats to the cart at the IBO's request.",
    createdAt: "2026-06-15T17:48:00Z",
  },
  {
    id: "note_006",
    iboId: "5327982",
    orderId: null,
    author: "Sam Lee",
    text: "Verified membership tier before applying the IBO discount.",
    createdAt: "2026-06-10T15:20:00Z",
  },
  {
    id: "note_007",
    iboId: "5327982",
    orderId: "WWG897588",
    author: "Sam Lee",
    text: "Order shipped priority. Tracking shared with customer.",
    createdAt: "2026-06-04T18:00:00Z",
  },
  {
    id: "note_008",
    iboId: "6184203",
    orderId: null,
    author: "Jordan Casey",
    text: "New single-person account. No prior order issues.",
    createdAt: "2026-06-24T20:15:00Z",
  },
];

export default notes;
